export default __webpack_public_path__ + "static/media/mongodb.ac47c497.png";